<script>
import PushNotificationsControl from "@/components/settings/PushNotificationsControl.vue";

export default {
  components: {
    PushNotificationsControl,
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0">Configurações</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-7 col-xl-6">
        <div class="card">
          <div class="card-body">
            <push-notifications-control />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
